import styled from 'styled-components'

import { Accordion as AccordionMUI } from '@mui/material'

export const Accordion = styled(AccordionMUI)`
  box-shadow: none;
  border-radius: 2.4rem !important;

  &.MuiAccordion-root {
    box-shadow: none;
    border-radius: 2.4rem !important;
  }

  &.Mui-expanded {
    border: none;
    box-shadow: none;
  }
`

export const GridHeader = styled.div`
  padding-top: 2.4rem;
  padding-left: 2.4rem;
  padding-bottom: 3.1rem;
`

export const BoxTitle = styled.h2``

export const Title = styled.div`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.secondary};
  font-weight: 600;
  padding-left: 1.2rem;
`
